import { compose } from 'recompose';
import HrConfirmDeleteModal from './hrConfirmDeleteModal';

const enhance = compose();
export default enhance(HrConfirmDeleteModal);
